(function () {
  'use strict';

  // Purchase controls win over compact launchers, never over an open conversation.
  if (window.__p4mMobilePurchaseGuardReady) return;
  window.__p4mMobilePurchaseGuardReady = true;

  var CONTROL_SELECTOR = 'variant-picker, variant-picker fieldset, variant-picker select, .product-form-buttons, .p4m-buy-confidence a, .p4m-buy-confidence button';
  var MARKER = 'data-p4m-purchase-guard-hidden';
  var CLEARANCE = 8;
  var owned = new Map();
  var shadowObservers = new Map();
  var resizeTargets = new Set();
  var frame = 0;
  var suspended = false;
  var retryTimer = 0;
  var pendingChat = null;
  var pendingChatAttempts = 0;
  var media = window.matchMedia('(max-width: 749px)');
  var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (!suspended && !frame) frame = window.requestAnimationFrame(update);
  }

  function visibleRect(node) {
    var rect = node.getBoundingClientRect();
    if (!(rect.width > 0 && rect.height > 0)) return null;
    var style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return null;
    return rect;
  }

  function overlaps(a, b) {
    return a.left < b.right + CLEARANCE && a.right > b.left - CLEARANCE &&
      a.top < b.bottom + CLEARANCE && a.bottom > b.top - CLEARANCE;
  }

  function ownsFocus(node) {
    var root = node.getRootNode();
    var active = root.activeElement || document.activeElement;
    return active === node || (active && node.contains(active));
  }

  function suppress(node, hide) {
    var previous = owned.get(node);
    if (hide && !previous) {
      previous = {
        visibility: node.style.getPropertyValue('visibility'),
        visibilityPriority: node.style.getPropertyPriority('visibility'),
        pointerEvents: node.style.getPropertyValue('pointer-events'),
        pointerEventsPriority: node.style.getPropertyPriority('pointer-events'),
        inert: node.getAttribute('inert'),
        marker: node.getAttribute(MARKER)
      };
      owned.set(node, previous);
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
      node.setAttribute('inert', '');
      node.setAttribute(MARKER, 'true');
    } else if (!hide && previous) {
      // Do not overwrite a later app-owned change to either inline property.
      if (node.style.getPropertyValue('visibility') === 'hidden' && node.style.getPropertyPriority('visibility') === 'important') {
        if (previous.visibility) node.style.setProperty('visibility', previous.visibility, previous.visibilityPriority);
        else node.style.removeProperty('visibility');
      }
      if (node.style.getPropertyValue('pointer-events') === 'none' && node.style.getPropertyPriority('pointer-events') === 'important') {
        if (previous.pointerEvents) node.style.setProperty('pointer-events', previous.pointerEvents, previous.pointerEventsPriority);
        else node.style.removeProperty('pointer-events');
      }
      if (node.getAttribute('inert') === '') {
        if (previous.inert === null) node.removeAttribute('inert');
        else node.setAttribute('inert', previous.inert);
      }
      if (previous.marker === null) node.removeAttribute(MARKER);
      else node.setAttribute(MARKER, previous.marker);
      owned.delete(node);
    }
  }

  function observeSizes(targets) {
    if (!resizeObserver) return;
    resizeTargets.forEach(function (node) {
      if (!targets.has(node)) {
        resizeObserver.unobserve(node);
        resizeTargets.delete(node);
      }
    });
    targets.forEach(function (node) {
      if (!resizeTargets.has(node)) {
        resizeObserver.observe(node);
        resizeTargets.add(node);
      }
    });
  }

  function discoverChatRoots(host) {
    var roots = [];
    var incomplete = host;
    if (host && host.shadowRoot) {
      roots.push(host.shadowRoot);
      host.shadowRoot.querySelectorAll('shopify-agent-runtime').forEach(function (runtime) {
        incomplete = runtime;
        if (runtime.shadowRoot) roots.push(runtime.shadowRoot);
      });
    }
    return { roots: roots, incomplete: incomplete };
  }

  function disconnectChatRoot(observer, root) {
    observer.disconnect();
    root.removeEventListener('focusin', schedule);
    root.removeEventListener('focusout', schedule);
  }

  function observeChatRoots(roots) {
    shadowObservers.forEach(function (observer, oldRoot) {
      if (roots.indexOf(oldRoot) === -1) {
        disconnectChatRoot(observer, oldRoot);
        shadowObservers.delete(oldRoot);
      }
    });
    roots.forEach(function (root) {
      if (shadowObservers.has(root)) return;
      var observer = new MutationObserver(schedule);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-expanded', 'aria-modal', 'aria-hidden', 'hidden', 'class', 'open', 'inert']
      });
      root.addEventListener('focusin', schedule);
      root.addEventListener('focusout', schedule);
      shadowObservers.set(root, observer);
    });
  }

  function hasOpenChatDialog(roots) {
    return roots.some(function (root) {
      return Array.prototype.some.call(root.querySelectorAll('[part~="dialog"], [role="dialog"]'), function (dialog) {
        return !dialog.hasAttribute('inert') && !dialog.hasAttribute('hidden') &&
          dialog.getAttribute('aria-hidden') !== 'true' && !!visibleRect(dialog);
      });
    });
  }

  function update() {
    frame = 0;
    var width = document.documentElement.clientWidth || window.innerWidth;
    var height = document.documentElement.clientHeight || window.innerHeight;
    var mobile = media.matches && width <= 749;
    var products = mobile ? document.querySelectorAll('.product-information') : [];
    var controls = [];
    var sizes = new Set();
    var activeWidgets = new Set();
    var viewport = { left: 0, top: 0, right: width, bottom: height };

    products.forEach(function (product) {
      product.querySelectorAll(CONTROL_SELECTOR).forEach(function (control) {
        sizes.add(control);
        var rect = visibleRect(control);
        if (rect && overlaps(rect, viewport)) controls.push(rect);
      });
    });

    var host = document.querySelector('shopify-chat');
    var chat = discoverChatRoots(host);
    observeChatRoots(chat.roots);
    var hasActivator = false;
    var dialogOpen = hasOpenChatDialog(chat.roots);
    chat.roots.forEach(function (root) {
      root.querySelectorAll('button[part="activator"]').forEach(function (activator) {
        hasActivator = true;
        var launcher = activator.closest('.activator-nudge') || activator;
        activeWidgets.add(launcher);
        sizes.add(activator);
        // Measure the compact activator, not either full-viewport custom-element host.
        var chatRect = activator.getBoundingClientRect();
        var expanded = host.hasAttribute('open') || root.host.hasAttribute('open') ||
          activator.getAttribute('aria-expanded') === 'true' || dialogOpen;
        var chatCollision = mobile && controls.length > 0 && !expanded && !ownsFocus(host) && !ownsFocus(launcher) &&
          chatRect.width > 0 && chatRect.height > 0 && overlaps(chatRect, viewport) &&
          controls.some(function (rect) { return overlaps(rect, chatRect); });
        suppress(launcher, chatCollision);
      });
    });

    var google = document.querySelector('#google-merchantwidget-iframe-wrapper');
    if (google) {
      activeWidgets.add(google);
      sizes.add(google);
      var googleRect = google.getBoundingClientRect();
      var compact = googleRect.width > 0 && googleRect.width <= 300 && googleRect.height > 0 && googleRect.height <= 160;
      var googleCollision = mobile && controls.length > 0 && compact && !ownsFocus(google) &&
        overlaps(googleRect, viewport) && controls.some(function (rect) { return overlaps(rect, googleRect); });
      suppress(google, googleCollision);
    }

    owned.forEach(function (_previous, node) {
      if (!activeWidgets.has(node)) suppress(node, false);
    });
    observeSizes(sizes);

    // A custom element can attach its shadow root without a document mutation.
    // Retry that one incomplete host briefly; later host insertion restarts discovery.
    if (mobile && products.length && host && !hasActivator) {
      if (pendingChat !== chat.incomplete) {
        pendingChat = chat.incomplete;
        pendingChatAttempts = 0;
      }
      if (!retryTimer && pendingChatAttempts < 60) {
        pendingChatAttempts += 1;
        retryTimer = window.setTimeout(function () { retryTimer = 0; schedule(); }, 1000);
      }
    } else {
      pendingChat = null;
      pendingChatAttempts = 0;
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = 0;
    }
  }

  function suspend() {
    suspended = true;
    if (frame) window.cancelAnimationFrame(frame);
    if (retryTimer) window.clearTimeout(retryTimer);
    frame = 0;
    retryTimer = 0;
    pendingChat = null;
    pendingChatAttempts = 0;
    owned.forEach(function (_previous, node) { suppress(node, false); });
    documentObserver.disconnect();
    shadowObservers.forEach(disconnectChatRoot);
    shadowObservers.clear();
    if (resizeObserver) resizeObserver.disconnect();
    resizeTargets.clear();
  }

  function resume() {
    suspended = false;
    documentObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pagehide', suspend);
  window.addEventListener('pageshow', resume);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
  }
  media.addEventListener && media.addEventListener('change', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('variant:update', schedule);
  document.addEventListener('load', schedule, true);
  var documentObserver = new MutationObserver(schedule);
  documentObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('shopify-chat').then(schedule);
    window.customElements.whenDefined('shopify-agent-runtime').then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  schedule();
})();
